import { useEffect, useState } from 'react'

import { Customer } from 'types/Customer'

import Api from 'services/api'

const useCustomer = (dealerId, customerId, refreshTimestamp) => {
  const [customer, setCustomer] = useState<Customer | null>(null)
  const [isCustomerLoaded, setIsCustomerLoaded] = useState(false)

  useEffect(() => {
    setIsCustomerLoaded(false)
    setCustomer(null)

    if (!dealerId || !customerId) {
      setIsCustomerLoaded(true)

      return
    }

    Api.Customer.get(dealerId, customerId)
      .then((res : Customer | null) => {
        setCustomer(res)
      })
      .catch(() => {
        setCustomer(null)
      })
      .finally(() => {
        setIsCustomerLoaded(true)
      })
  }, [dealerId, customerId, refreshTimestamp])

  return { customer, isCustomerLoaded }
}

export default useCustomer
